import { render, staticRenderFns } from "./WhatsNewModal.vue?vue&type=template&id=e3921d62&scoped=true"
import script from "./WhatsNewModal.vue?vue&type=script&lang=js"
export * from "./WhatsNewModal.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewModal.vue?vue&type=style&index=0&id=e3921d62&prod&lang=css"
import style1 from "./WhatsNewModal.vue?vue&type=style&index=1&id=e3921d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3921d62",
  null
  
)

export default component.exports